import styled from 'styled-components'

const Button = styled.button`
    width: 155px;
    height: 55px;
    background-color: #112172;
    COLOR: #FFF;
    border: 1px solid #112172;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.4s;
    font-family: 'Montserrat';

    &:hover {
        background-color: #3755e1;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
`

export default Button;